// @ts-nocheck

import React, { useContext, useMemo } from 'react';
import styled, { css } from 'styled-components';

import useDelayedPropVariation from '../../../hooks/useDelayedPropVariation';
import { KLRound2Flag } from '../assets/img/flags';
import KLCollarCounterContainer from '../containers/KLCollarCounterContainer';
import KLRulesButtonContainer from '../containers/KLRulesButtonContainer';
import KLVotesAgainstUserCounterContainer from '../containers/KLVotesAgainstUserCounterContainer';
import { KLRound2CollectibleIds } from '../types/collectible';
import { KLRounds } from '../types/round';

import KLBadgeList from './common/KLBadgeList';
import KLViewWrapper, { KLViewContext } from './common/KLViewWrapper';

const roundId = KLRounds.T_WHITE;

const StyleReceiver = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const RoundInfosAndRulesRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  margin-bottom: calc(var(--KLViewWrapper-availableHeight) * 0.2);
`;

const RoundFlag = styled.img`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -25%);
  width: calc(var(--KLViewWrapper-availableHeight) * 0.3);

  background-repeat: no-repeat;
  object-position: center;
  object-fit: cover;
`;

const UserInfosRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $isASmallDevice }) =>
    $isASmallDevice
      ? css`
          margin-bottom: calc(var(--KLViewWrapper-availableHeight) * 0.1);
        `
      : css`
          margin-bottom: calc(var(--KLViewWrapper-availableHeight) * 0.06);
        `}
`;

const countersSharedStyle = css`
  font-size: 1.8em;
`;

const StyledCollarCounter = styled(KLCollarCounterContainer)`
  ${countersSharedStyle}
  margin-right: 2em;
`;

const StyledVotesAgainstUserCounter = styled(KLVotesAgainstUserCounterContainer)`
  ${countersSharedStyle}
`;

const StyledKLBadgeList = styled(KLBadgeList)`
  ${({ $isASmallDevice }) =>
    $isASmallDevice
      ? css`
          transform: translateY(-15%) scale(0.85);
        `
      : undefined}
`;

type KLRound2Props = {
  className?: string;
  children?: React.ReactNode;
  isLocked: boolean;
};

const KLRound2 = ({ className = '', isLocked = false, children }: KLRound2Props) => {
  const { width, height } = useContext(KLViewContext);

  const isASmallDevice = useMemo(() => height / width < 1.8, [height, width]);
  const [delayedIsLocked, prevDelayedIsLocked] = useDelayedPropVariation(isLocked);

  return (
    <KLViewWrapper
      className={className}
      viewType={roundId}
      isLocked={delayedIsLocked}
      prevIsLocked={prevDelayedIsLocked}
    >
      <StyleReceiver>
        <RoundInfosAndRulesRow>
          <RoundFlag src={KLRound2Flag} alt="Drapeau équipe blanche" />
          <KLRulesButtonContainer roundId={roundId} />
        </RoundInfosAndRulesRow>
        <UserInfosRow $isASmallDevice={isASmallDevice}>
          <StyledCollarCounter roundIndex={1} />
          <StyledVotesAgainstUserCounter roundIndex={1} />
        </UserInfosRow>
        <StyledKLBadgeList badgeIds={KLRound2CollectibleIds} badgesByRow={3} $isASmallDevice={isASmallDevice} />
        {children}
      </StyleReceiver>
    </KLViewWrapper>
  );
};

export default KLRound2;
